<div class="footer-content">
    <p class="mb-0">© 2025 Designed and Programmed in INDIA by Designed by <a href="https://compubrain.com/" target="_blank"><img class="img-fluid" src="assets/images/logo/CompuBrain.svg" alt="logo"/></a></p>
    <span>
        <a href="" class="text-gray me-3">Term &amp; Conditions</a>
        <a href="" class="text-gray">Privacy &amp; Policy</a>
    </span>
</div>